import { render, staticRenderFns } from "./DispenserUsage.vue?vue&type=template&id=181e9b91"
import script from "./DispenserUsage.vue?vue&type=script&lang=js"
export * from "./DispenserUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports